export const SIGNATURE_SETTINGS_DESCRIPTION = 'Manage the signature for IAC';

export const SIGNATURE_MAX_FILE_SIZE = 2097152;

export const SIGNATURE_MAX_FILE_SIZE_ERROR = 'Maximum image size is 2mb';
